import { Contractor_Rating_Aggregate } from "@/generated/graphql";

export function getContractorRating(ratingTotal: Contractor_Rating_Aggregate): number {
  const { aggregate } = ratingTotal;
  if (!aggregate) {
    return 0;
  }

  const { count: numberOfReviews, sum } = aggregate;
  const ratingSum = sum?.score;

  if (!ratingSum || !numberOfReviews) {
    return 0;
  }

  return Math.round((ratingSum / numberOfReviews) * 10) / 10;
}
